export default "__VITE_ASSET__CeLbaP3G__"